<template>
  <div class="footer-wrapper">
    <div class="container-fluid">
      <section class="partners p-5">
        <h5 class="text-center mb-5"><strong>Redes</strong> que já <strong>fazem parte </strong> da Biobá:</h5>
        <div class="container-fluid">
          <div class="organizations d-flex flex-wrap justify-content-center">
            <template v-for="organization in organizations">
              <div v-if="organization.images && organization.images.length" :key="organization._id" class="p-2">
                <div class="thumb mb-2 d-flex align-items-center" :title="organization.name">
                  <b-img :src="baseUrl + organization.images[0].thumb" />
                </div>
              </div>
            </template>
          </div>
        </div>
        <h5 class="text-center mb-5 mt-5"><strong>Fornecedores</strong> que já <strong>fazem parte </strong> da Biobá:</h5>
        <div class="container-fluid">
          <div class="suppliers d-flex flex-wrap justify-content-center">
            <template v-for="supplier in suppliers">
              <div v-if="supplier.images && supplier.images.length" :key="supplier._id" class="p-2">
                <div class="thumb mb-2 d-flex align-items-center" :title="supplier.name">
                  <b-img :src="baseUrl + supplier.images[0].thumb" />
                </div>
              </div>
            </template>
          </div>
        </div>
      </section>
    </div>
    <footer>
      <div class="d-flex align-items-center p-5">
        <div class="">
          <img src="../assets/img/logo-white.svg" class="logo" />
        </div>
        <div class="contact ml-auto">
          bioba@bioba.com.br
        </div>
      </div>
    </footer>
  </div>
  <!-- teste -->
  <!-- teste 1 -->
  <!-- teste 12 -->
  <!-- teste 12 -->
  <!-- teste 123 -->
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      organizations: [],
      suppliers: []
    }
  },
  created () {
    axios.get('organizations').then(response => {
      this.organizations = response.data
    }).catch(this.showError)
    axios.get('suppliers').then(response => {
      this.suppliers = response.data
    }).catch(this.showError)
  }
}
</script>
<style lang="sass" scoped>
  .partners
    background-color: #fff
    border-top-left-radius: 30px
    border-top-right-radius: 30px
    h5
      font-weight: 100
    .thumb
      text-align: center
      width: 100px
      height: 100px
      border: 1px solid #f0f0f0
      border-radius: 15px
      overflow: hidden
      img
        max-width: 100%
  footer
    background-image: url("../assets/img/bg-footer.png")
    background-size: 100%
    background-position: center
    background-repeat: repeat-y
    border-top-left-radius: 15px
    border-top-right-radius: 15px
    width: 100%
    .logo
    .contact
      font-size: 20px
      font-weight: 100
      color: #fff
      @media(max-width: 768px)
        font-size: 16px
</style>
